import React from 'react';
import { Empty } from 'antd'; // Import Empty
import './styles/SentimentAnalysis.css';

// Helper function to find the max count for scaling bars
const findMaxCount = (keywords) => {
  if (!keywords || keywords.length === 0) return 1; // Avoid division by zero
  return Math.max(...keywords.map(k => k.mentions), 1); // Ensure max is at least 1
};

const SentimentAnalysis = ({ loading, error, data }) => {
  // Use fetched data if available, otherwise default to empty arrays
  const positiveKeywords = data?.positive || [];
  const negativeKeywords = data?.negative || [];

  // Calculate max counts for scaling progress bars
  const maxPositiveCount = findMaxCount(positiveKeywords);
  const maxNegativeCount = findMaxCount(negativeKeywords);

  if (loading) {
    return (
      <div className="sentiment-analysis loading-state">
        <h2>Review Sentiment Analysis</h2>
        <p>Loading themes...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="sentiment-analysis error-state">
        <h2>Review Sentiment Analysis</h2>
        <p className="error-message">Error loading themes: {error}</p>
      </div>
    );
  }

  const hasPositive = positiveKeywords.length > 0;
  const hasNegative = negativeKeywords.length > 0;

  return (
    <div className="sentiment-analysis">
      <h2>Review Sentiment Analysis</h2>

      {(!hasPositive && !hasNegative) ? (
        <Empty description="No sentiment themes found for the selected period. As you receive reviews, themes will appear here." />
      ) : (
        <div className="sentiment-grid">
          {hasPositive && (
            <div className="sentiment-column positive">
              <h3>Top Positive Themes</h3>
              <div className="keyword-list">
                {positiveKeywords.map((keyword, index) => (
                  <div key={`pos-${index}`} className="keyword-item">
                    <div className="keyword-text">{keyword.theme}</div>
                    <div className="keyword-bar">
                      <div
                        className="keyword-progress"
                        style={{
                          width: `${(keyword.mentions / maxPositiveCount) * 100}%`,
                          backgroundColor: '#10b981' // green
                        }}
                      ></div>
                    </div>
                    <div className="keyword-count">
                      {keyword.mentions} mentions
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}

          {hasNegative && (
            <div className="sentiment-column negative">
              <h3>Top Negative Themes</h3>
              <div className="keyword-list">
                {negativeKeywords.map((keyword, index) => (
                  <div key={`neg-${index}`} className="keyword-item">
                    <div className="keyword-text">{keyword.theme}</div>
                    <div className="keyword-bar">
                      <div
                        className="keyword-progress"
                        style={{
                          width: `${(keyword.mentions / maxNegativeCount) * 100}%`,
                          backgroundColor: '#ef4444' // red
                        }}
                      ></div>
                    </div>
                    <div className="keyword-count">
                      {keyword.mentions} mentions
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default SentimentAnalysis;